{
  "auth": {
    "agree": "Tôi đồng ý với",
    "createAccount": "Tạo tài khoản",
    "email": "Email",
    "login": "Đăng nhập",
    "password": "Mật khẩu",
    "recover_password": "Khôi phục mật khẩu",
    "sign_up": "Đăng ký",
    "keep_logged_in": "Ghi nhớ đăng nhập",
    "termsOfUse": "Điều khoản sử dụng",
    "reset_password": "Đặt lại mật khẩu"
  },
  "menu": {
    "auth": "Xác thực",
    "dashboard": "Tổng quan",
    "dealers": "Quản lý đại lý",
    "transactions": "Quản lý giao dịch",
    "transactionImport": "Nhập giao dịch",
    "transactionHistory": "Lịch sử nhập",
    "consolidatedTransactions": "Giao dịch tích điểm",
    "showroomTransactions": "Giao dịch tích điểm",
    "giftTransactions": "Quà tặng",
    "transactionConflicts": "Xử lý xung đột",
    "billing": "Thanh toán",
    "login": "Đăng nhập",
    "preferences": "Tùy chọn tài khoản",
    "payments": "Thanh toán",
    "settings": "Cài đặt",
    "pricing-plans": "Gói dịch vụ",
    "payment-methods": "Phương thức thanh toán",
    "signup": "Đăng ký",
    "recover-password": "Khôi phục mật khẩu",
    "recover-password-email": "Email khôi phục mật khẩu",
    "404": "404",
    "faq": "Câu hỏi thường gặp",
    "users": "Người dùng",
    "projects": "Dự án"
  },
  "user": {
    "language": "Đổi ngôn ngữ",
    "logout": "Đăng xuất",
    "profile": "Hồ sơ",
    "settings": "Cài đặt",
    "billing": "Thanh toán",
    "faq": "Câu hỏi thường gặp",
    "helpAndSupport": "Trợ giúp và hỗ trợ",
    "projects": "Dự án",
    "account": "Tài khoản",
    "explore": "Khám phá"
  },
  "navbar": { "messageUs": "Liên hệ phát triển web:", "repository": "Kho mã GitHub" },
  "helpAndSupport": "Trợ giúp và hỗ trợ",
  "aboutVuesticAdmin": "Giới thiệu Vuestic Admin",
  "supportAndConsulting": "Hỗ trợ và tư vấn",
  "search": { "placeholder": "Tìm kiếm..." },
  "vuestic": {
    "search": "Tìm kiếm",
    "noOptions": "Không tìm thấy mục nào",
    "ok": "Đồng ý",
    "cancel": "Hủy",
    "uploadFile": "Tải tệp lên",
    "undo": "Hoàn tác",
    "dropzone": "Thả tệp vào đây để tải lên",
    "fileDeleted": "Đã xóa tệp",
    "closeAlert": "đóng thông báo",
    "backToTop": "về đầu trang",
    "toggleDropdown": "bật/tắt danh sách",
    "close": "đóng",
    "next": "Tiếp theo",
    "back": "Quay lại",
    "finish": "Hoàn tất",
    "loading": "Đang tải",
    "select": "Chọn một tùy chọn",
    "pagination": "phân trang",
    "goToTheFirstPage": "về trang đầu",
    "goToPreviousPage": "về trang trước",
    "goNextPage": "sang trang sau",
    "goLastPage": "đến trang cuối",
    "reset": "Đặt lại",
    "resetDate": "Đặt lại ngày",
    "nextPeriod": "Kỳ tiếp theo",
    "previousPeriod": "Kỳ trước",
    "removeFile": "Xóa tệp",
    "noSelectedOption": "Chưa chọn tùy chọn",
    "selectedOption": "Đã chọn tùy chọn",
    "fileTypeIncorrect": "Loại tệp không đúng",
    "closeToast": "đóng thông báo"
  },
  "messages": { "all": "Xem tất cả tin nhắn", "new": "Tin nhắn mới từ {name}", "mark_as_read": "Đánh dấu đã đọc" },
  "notifications": {
    "all": "Xem tất cả thông báo",
    "less": "Thu gọn thông báo",
    "mark_as_read": "Đánh dấu đã đọc",
    "sentMessage": "đã gửi tin nhắn cho bạn",
    "uploadedZip": "đã tải lên tệp ZIP mới với {type}",
    "startedTopic": "đã bắt đầu chủ đề mới"
  },
  "404": {
    "title": "Không tìm thấy trang",
    "text": "Trang bạn yêu cầu không tồn tại.",
    "back_button": "Về trang tổng quan"
  },
  "dashboard": {
    "versions": "Phiên bản",
    "setupRemoteConnections": "Thiết lập kết nối từ xa",
    "currentVisitors": "Lượt truy cập hiện tại",
    "navigationLayout": "Bố cục điều hướng",
    "topBarButton": "Thanh trên",
    "sideBarButton": "Thanh bên"
  }
}
